<template>
    <modal name="no-watchlists-yet"
           width="80%"
           height="auto"
           :max-width="700"
           :adaptive="true"
    >
        <div class="no-watchlists-yet__content">
            <h1 class="no-watchlists-yet__title" v-html="$t('NoWatchListsYetModal.title')"></h1>
            <p class="no-watchlists-yet__instructions" v-html="$t('NoWatchListsYetModal.creation_instructions')"></p>
            <p class="no-watchlists-yet__instructions" v-html="getInstructionsWithIcon"></p>
            <div class="no-watchlists-yet__buttons">
                <TotemButton color="basic" icon="cancel" @click="hideModal" class="no-watchlists-yet__button -hide" :label="$t('General.close')" />
            </div>
        </div>
    </modal>
</template>

<script>
    export default {
        name: 'no-watchlists-yet-modal',
        computed: {
            getInstructionsWithIcon () {
                return this.$t('NoWatchListsYetModal.adding_instructions', { watchListIcon: '<img style="height: 35px; position: relative; top: 12px; margin; 4px; alt="icon" src=' + '"' + this.bookmarkImage + '"/>' })
            },
            bookmarkImage () {
                return require(`@/assets/images/icons/bookmark_icon_orange.png`)
            }
        },
        methods: {
            hideModal () {
                this.$modal.hide('no-watchlists-yet')
            }
        }
    }
</script>

<style lang="scss" scoped>
.no-watchlists-yet {
    &__content {
        background: $white;
        padding: 60px 40px;

        [class*="desktop"] & {
            padding: 30px;
        }
    }

    &__title {
        font-size: 2.5rem;
        margin: 0 0 20px;
        font-weight: 400;
        font-family: Quicksand-Regular, sans-serif;
        text-align: center;

        [class*="mobile"] & {
            font-size: 2rem;
        }
    }

    &__instructions {
        margin: 20px 0;
        font-family: 'Nunito-Bold';
        font-weight: 400;

        [class*="mobile"] & {
            font-size: 1.4rem;
        }
        span {
            margin: 5px;
        }
    }

    &__buttons {
        display: flex;
        justify-content: center;
        flex-direction: column;

        [class*="desktop"] & {
            flex-direction: row;
        }
    }

    &__button {
        align-self: center;
    }
}
</style>
